import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _MatchingTypeTable;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/es/format-message';
import { Table } from '@instructure/ui-table';
import { jsx } from '@instructure/emotion';
import PropTypes from 'prop-types';
import { IconCheckSolid } from '@instructure/ui-icons';
import { matchingTypeAnswerSummaryPropType } from '../../../../common/propTypes';
import MatchingTypeOrderer from '../utils/matchingTypeOrderer';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import generateComponentTheme from './theme';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var MatchingTypeTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_MatchingTypeTable = /*#__PURE__*/function (_Component) {
  function MatchingTypeTable() {
    var _this;
    _classCallCheck(this, MatchingTypeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MatchingTypeTable, [].concat(args));
    _defineProperty(_this, "renderIcon", function () {
      return jsx("div", {
        css: [_this.props.styles.iconWrapper, _this.props.styles.iconCorrect]
      }, jsx(IconCheckSolid, null));
    });
    _defineProperty(_this, "renderHeaderCell", function (key) {
      var _this$props = _this.props,
        answerSummary = _this$props.answerSummary,
        itemId = _this$props.itemId;
      var questions = answerSummary.questions;
      var questionKeys = Object.keys(questions);
      var exampleAnswers = questions[questionKeys[0]].answers;
      var answer = exampleAnswers[key];
      var answerNumberHeaderId = "answer-number-header-".concat(key, "-").concat(itemId);
      return jsx(Table.ColHeader, {
        id: answerNumberHeaderId,
        key: answerNumberHeaderId,
        themeOverride: {
          padding: '0 0 15px 0'
        },
        textAlign: "center"
      }, jsx(Flex, {
        direction: "row"
      }, jsx(Flex.Item, {
        width: "46px",
        textAlign: "center"
      }), jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true,
        textAlign: "center"
      }, answer.body)));
    });
    _defineProperty(_this, "answerLabel", function (correct) {
      return correct ? t('Correct answer') : t('Incorrect answer');
    });
    _defineProperty(_this, "renderCell", function (questionKey, answerKey) {
      var _this$props2 = _this.props,
        answerSummary = _this$props2.answerSummary,
        itemId = _this$props2.itemId;
      var questions = answerSummary.questions;
      var question = questions[questionKey];
      var answer = question.answers[answerKey];
      var correct = answer.correct,
        count = answer.count;
      var answerNumberCellId = "answer-number-cell-".concat(questionKey, "-").concat(answerKey, "-").concat(itemId);
      var answerRowStyles = answer.correct ? _this.props.styles.correctAnswerRow : {};
      return jsx(Table.Cell, {
        id: answerNumberCellId,
        key: answerNumberCellId,
        themeOverride: {
          padding: '0 0 0 0'
        }
      }, jsx(ScreenReaderContent, null, correct ? "".concat(t('Correct answer'), ": ").concat(count) : count), jsx("div", {
        "aria-hidden": "true",
        css: answerRowStyles
      }, jsx(Flex, {
        direction: "row",
        alignItems: "center"
      }, jsx(Flex.Item, {
        width: "46px",
        textAlign: "center",
        align: "stretch"
      }, correct && _this.renderIcon()), jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true,
        textAlign: "center"
      }, count))));
    });
    _defineProperty(_this, "renderHeaderRow", function (orderedAnswerKeys) {
      var _this$props3 = _this.props,
        itemId = _this$props3.itemId,
        firstColumnName = _this$props3.firstColumnName;
      var headerCells = orderedAnswerKeys.map(_this.renderHeaderCell);
      var categoryHeaderId = "category-header-".concat(itemId);
      var rowKey = "header-row-".concat(itemId);
      return jsx(Table.Row, {
        key: rowKey
      }, jsx(Table.ColHeader, {
        id: categoryHeaderId,
        key: categoryHeaderId,
        themeOverride: {
          padding: '0 0 15px 0'
        },
        textAlign: "start",
        width: "250px"
      }, firstColumnName), headerCells);
    });
    _defineProperty(_this, "renderRow", function (orderedQuestionKey, orderedAnswerKeys) {
      var _this$props4 = _this.props,
        answerSummary = _this$props4.answerSummary,
        itemId = _this$props4.itemId,
        firstColumnName = _this$props4.firstColumnName;
      var questions = answerSummary.questions;
      var question = questions[orderedQuestionKey];
      var answerCells = orderedAnswerKeys.map(function (answerKey) {
        return _this.renderCell(orderedQuestionKey, answerKey);
      });
      var questionRowHeaderId = "question-row-header-id-".concat(orderedQuestionKey, "-").concat(itemId);
      var rowKey = "row-".concat(orderedQuestionKey, "-").concat(itemId);
      var extractedQuestionBody = extractTextFromHtml(question.body);
      var questionBody = extractedQuestionBody.trim().length > 0 ? extractedQuestionBody : firstColumnName;
      return jsx(Table.Row, {
        key: rowKey
      }, jsx(Table.RowHeader, {
        id: questionRowHeaderId,
        key: questionRowHeaderId,
        themeOverride: {
          padding: '12px 12px 12px 0'
        }
      }, questionBody), answerCells);
    });
    _defineProperty(_this, "render", function () {
      var answerSummary = _this.props.answerSummary;
      var questions = answerSummary.questions;
      var questionKeys = Object.keys(questions);
      var exampleAnswers = questions[questionKeys[0]].answers;
      var answerKeys = Object.keys(exampleAnswers).sort();
      var orderedAnswerKeys = MatchingTypeOrderer.orderAnswerKeysForDiagonal(answerSummary, answerKeys);
      var orderedQuestionKeys = MatchingTypeOrderer.orderQuestionKeysForDiagonal(answerSummary, questionKeys, orderedAnswerKeys);
      return jsx("div", {
        css: _this.props.styles.tableContainer
      }, jsx(Table, {
        caption: t('Answer Frequency Summary')
      }, jsx(Table.Head, null, _this.renderHeaderRow(orderedAnswerKeys)), jsx(Table.Body, null, orderedQuestionKeys.map(function (orderedQuestionKey) {
        return _this.renderRow(orderedQuestionKey, orderedAnswerKeys);
      }))));
    });
    return _this;
  }
  _inherits(MatchingTypeTable, _Component);
  return _createClass(MatchingTypeTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }]);
}(Component), _defineProperty(_MatchingTypeTable, "displayName", 'MatchingTypeTable'), _defineProperty(_MatchingTypeTable, "componentId", "Quizzes".concat(_MatchingTypeTable.displayName)), _defineProperty(_MatchingTypeTable, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: matchingTypeAnswerSummaryPropType.isRequired,
  firstColumnName: PropTypes.string.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _MatchingTypeTable)) || _class);